import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HandshakeSharpIcon from "@mui/icons-material/HandshakeSharp";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import NoteOutlinedIcon from "@mui/icons-material/NoteOutlined";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
// import RocketOutlinedIcon from "@mui/icons-material/RocketOutlined";
import SailingRoundedIcon from "@mui/icons-material/SailingRounded";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import SyncAltOutlinedIcon from "@mui/icons-material/SyncAltOutlined";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import UpdateSharpIcon from "@mui/icons-material/UpdateSharp";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import React, { useEffect } from "react";
import { Tooltip } from "@mui/material";
import { ButtonGroup, Dropdown } from "react-bootstrap";
// import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import CloseIcon from "@mui/icons-material/Close";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import ReplayIcon from "@mui/icons-material/Replay";
import SendIcon from '@mui/icons-material/Send';
import Transit from '@mui/icons-material/TransferWithinAStation';
import AcceptRejectIcon from "../../assets/images/icons/AcceptRejectIcon.svg";
import ActionRequiredIcon from "../../assets/images/icons/ActionRequired.svg";
import AdminAcceptedIcon from "../../assets/images/icons/AdminAccepted.svg";
import AdminRejectedIcon from "../../assets/images/icons/AdminRejected.svg";
import ActiveIcon from "../../assets/images/icons/ActiveIcon.svg";
import ExpiredIcon from "../../assets/images/icons/ExpiredIcon.svg";
import ExpandMore from '../../assets/images/icons/ExpandMore.svg';
import InProgress from "../../assets/images/icons/InProgress.svg";
import InvoiceRaised from "../../assets/images/icons/InvoiceRaisedIcon.svg";
import ReOpenRequestIcon from "../../assets/images/icons/ReopenRequestIcon.svg";
import SellerAccepted from "../../assets/images/icons/SellerAcceptedIcon.svg";
import SellerRejected from "../../assets/images/icons/SellerRejectedIcon.svg";
import UnderReviewBySeller from "../../assets/images/icons/UnderReviewBySellerIcon.svg";
import UnderReviewByWDTP from "../../assets/images/icons/UnderReviewByWDTPIcon.svg";
import UserCheck from "../../assets/images/icons/UserCheck.svg";
import UserPlus from "../../assets/images/icons/UserPlus.svg";
import UserSend from "../../assets/images/icons/UserSend.svg";
import UpsizingIcon from "../../assets/images/icons/UpsizingIcon.svg";
import DownsizingIcon from "../../assets/images/icons/DownsizingIcon.svg";
import NormalUsageIcon from "../../assets/images/icons/NormalUsageIcon.svg";
import { CommonService } from "../../Service/CommonService";
import { SupportApiService } from "../../Service/SupportApiService";
import RepeatIcon from '@mui/icons-material/Repeat';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Spinner from "./Spinner";
import LoopOutlinedIcon from '@mui/icons-material/LoopOutlined';
import RocketOutlinedIcon from '@mui/icons-material/RocketOutlined';
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import ReassignToAdmin from "../../assets/images/icons/ReassignToAdmin.svg";
import WarehouseCompleted from "../../assets/images/icons/WarehouseCompleted.svg";
import TaskAltTwoToneIcon from '@mui/icons-material/TaskAltTwoTone';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import InStageIcon from "../../assets/images/icons/InStageIcon.svg";
import ScheduledIcon from "../../assets/images/icons/ScheduledIcon.png";
import WarehouseConfirmed from "../../assets/images/icons/WarehouseConfirmed.svg";
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';

// Create a simple global event system for dropdowns
const dropdownEventSystem = {
  currentOpenDropdownId: null,
  listeners: new Set<Function>(),
  
  setOpenDropdown(id: string | null) {
    this.currentOpenDropdownId = id;
    this.notifyListeners();
  },
  
  subscribe(listener: Function) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  },
  
  notifyListeners() {
    this.listeners.forEach(listener => listener(this.currentOpenDropdownId));
  }
};

interface StatusOption {
  key: string;
  label: string;
  icon: React.ReactNode;
  action: string;
}

interface StatusDropdownProps {
  currentStatus: string;
  onStatusChange: (newStatus: string) => void;
  disableCondition: boolean;
  allowedLabels: string[];
  serviceTypeId?: any;
  isDestinationCompany?: boolean;
  showTooltip?: boolean;
}

const StatusDropdown: React.FC<StatusDropdownProps> = ({
  currentStatus,
  onStatusChange,
  disableCondition,
  allowedLabels,
  serviceTypeId,
  isDestinationCompany,
  showTooltip = true
}) => {
  // Generate a unique ID for this dropdown instance
  const dropdownId = React.useRef(
    `dropdown-${Math.random().toString(36).substring(2, 9)}`
  );
  const [isOpen, setIsOpen] = React.useState(false);
  const [dynamicLabels, setDynamicLabels] = React.useState<string[]>(allowedLabels);
  const [isLoading, setIsLoading] = React.useState(false);


  // Subscribe to the global dropdown event system
  useEffect(() => {
    const unsubscribe = dropdownEventSystem.subscribe((openDropdownId: string | null) => {
      // Close this dropdown if another one opens
      if (openDropdownId !== dropdownId.current && isOpen) {
        setIsOpen(false);
      }
    });

    return unsubscribe;
  }, [isOpen]);

  // useEffect (() => {

  //   if(serviceTypeId) {
  //     getAllStatus();
  //   }
  // },[])

  // Handle dropdown toggle
  const handleToggle = (nextIsOpen: boolean) => {
    if (nextIsOpen) {
      // Notify the system that this dropdown is now open
      dropdownEventSystem.setOpenDropdown(dropdownId.current);
    }

    if (serviceTypeId && !isOpen) {
      getAllStatus();
    }
    setIsOpen(nextIsOpen);
  };

  const statusOptions: StatusOption[] = [
    {
      key: "Invited",
      action: "Invite",
      label: "Invited",
      icon: <SendIcon sx={{ color: "#328fa8" }} fontSize="small" />,
    },
    {
      key: "Pending Review",
      action: "Pending Review",
      label: "Pending Review",
      icon: (
        <HourglassEmptyOutlinedIcon
          sx={{ color: "#737376" }}
          fontSize="small"
        />
      ),
    },
    {
      key: "Submit for Review",
      action: "Submit for Review",
      label: "Submit for Review",
      icon: (
        <UploadFileOutlinedIcon sx={{ color: "#952698" }} fontSize="small" />
      ),
    },
    {
      key: "Approved",
      action: "Approve",
      label: "Approved",
      icon: <VerifiedOutlinedIcon sx={{ color: "#FF8B03" }} fontSize="small" />,
    },
    {
      key: "Shipped",
      action: "Ship",
      label: "Shipped",
      icon: <SailingRoundedIcon sx={{ color: "#28C1B8" }} fontSize="small" />,
    },
    {
      key: "Contract Sign",
      action: "Sign Contract",
      label: "Contract Sign",
      icon: (
        <StickyNote2OutlinedIcon sx={{ color: "#9025B6" }} fontSize="small" />
      ),
    },
    {
      key: "Pending for Contract",
      action: "Pending for Contract",
      label: "Pending for Contract",
      icon: <NoteOutlinedIcon sx={{ color: "#80A72D" }} fontSize="small" />,
    },
    {
      key: "Under Review",
      action: "Under Review",
      label: "Under Review",
      icon: <UpdateSharpIcon sx={{ color: "#D849B0" }} fontSize="small" />,
    },
    {
      key: "Accepted",
      action: "Accept",
      label: "Accepted",
      icon: <ThumbUpOffAltIcon sx={{ color: "#5fb73a" }} fontSize="small" />,
    },
    {
      key: "Finalized",
      action: "Finalize",
      label: "Finalized",
      icon: <FlagOutlinedIcon sx={{ color: "#39678A" }} fontSize="small" />,
    },
    {
      key: "Published",
      action: "Publish",
      label: "Published",
      icon: (
        <RocketLaunchOutlinedIcon sx={{ color: "#7E9C97" }} fontSize="small" />
      ),
    },
    {
      key: "Unpublished",
      action: "Unpublish",
      label: "Unpublished",
      icon: <RocketOutlinedIcon sx={{ color: "#E48486" }} fontSize="small" />,
    },
    {
      key: "Upload Failed",
      action: "Upload Failed",
      label: "Upload Failed",
      icon: "", // this will empty because as of now don't have any icon for this status
    },
    {
      key: "Republished",
      action: "Republish",
      label: "Republished",
      icon: <PublishedWithChangesOutlinedIcon sx={{color: "#525E9D"}} fontSize="small" />,
    },
    {
      key: "In Progress",
      action: "In Progress",
      label: "In Progress",
      icon: <img src={InProgress} />,
    },
    {
      key: "In Process",
      action: "In Process",
      label: "In Process",
      icon: <img src={InProgress} />,
    },
    {
      key: "Source Accepted",
      action: "Source Accepted",
      label: "Source Accepted",
      icon: <img src={AdminAcceptedIcon} />,
    },
    {
      key: "Source Rejected",
      action: "Source Rejected",
      label: "Source Rejected",
      icon: <NotInterestedIcon sx={{ color: "#EC2323" }} fontSize="small" />
    },
    {
      key: "Destination Accepted",
      action: "Destination Accepted",
      label: "Destination Accepted",
      icon: <img src={AdminAcceptedIcon} />,
    },
    {
      key: "Destination Rejected",
      action: "Destination Rejected",
      label: "Destination Rejected", 
      icon: <NotInterestedIcon sx={{ color: "#EC2323" }} fontSize="small" />
    },
    {
      key: "Re-Open",
      action: "Re-Open",
      label: "Re-Open",
      icon: <img src={ReOpenRequestIcon} />,
    },
    {
      key: "Confirmed",
      action: "Confirmed",
      label: "Confirmed",
      icon: <TaskAltTwoToneIcon sx={{ color: "#196FA4" }} fontSize="small" />,
    },
    {
      key: "In Stage",
      action: "In Stage",
      label: "In Stage",
      icon: <img src={InStageIcon} />,
    },
    {
      key: "Completed",
      action: "Completed",
      label: "Completed",
      icon: <ThumbUpOffAltIcon sx={{ color: "#5fb73a" }} fontSize="small" />,
    },
    {
      key: "Deleted",
      action: "Delete",
      label: "Deleted",
      icon: <DeleteOutlineIcon sx={{ marginLeft: "-4px" }} />,
    },
    {
      key: "Scheduled",
      action: "Scheduled",
      label: "Scheduled",
      icon: <img src={ScheduledIcon} />,
    },
    {
      key: "Assigned",
      action: "Assigned",
      label: "Assigned",
      icon: <ThumbUpOffAltIcon sx={{ color: "#5fb73a" }} fontSize="small" />,
    },
    {
      key: "Failed",
      action: "Failed",
      label: "Failed",
      icon: <CloseIcon sx={{ marginLeft: "-4px" }} />,
    },
    {
      key: "Uploaded",
      action: "Upload",
      label: "Uploaded",
      // icon: <FlagOutlinedIcon sx={{ color: "#39678A" }} fontSize="small" />,
      icon: <CloudDoneOutlinedIcon  sx={{ color: "#39678A" }} fontSize="small"/>
      
    },
    {
      key: "Contract Sent",
      action: "Send Contract",
      label: "Contract Sent",
      icon: (
        <EventNoteOutlinedIcon sx={{ color: "#D3A54D" }} fontSize="small" />
      ),
    },
    {
      key: "Contract Executed",
      action: "Execute Contract",
      label: "Contract Executed",
      icon: <HandshakeSharpIcon sx={{ color: "#B89273" }} fontSize="small" />,
    },
    {
      key: "Invoice Sent",
      action: "Send Invoice",
      label: "Invoice Sent",
      icon: (
        <UploadFileOutlinedIcon sx={{ color: "#9BB078" }} fontSize="small" />
      ),
    },
    {
      key: "Payment Received",
      action: "Payment Receive",
      label: "Payment Received",
      icon: (
        <MonetizationOnOutlinedIcon
          sx={{ color: "#586C53" }}
          fontSize="small"
        />
      ),
    },
    {
      key: "Ownership Transferred",
      action: "Transfer Ownership",
      label: "Ownership Transferred",
      icon: <SyncAltOutlinedIcon sx={{ color: "#4687D4" }} fontSize="small" />,
    },
    {
      key: "Under Review by Seller",
      action: "Under Review by Seller",
      label: "Under Review by Seller",
      icon: <img src={UnderReviewBySeller} />,
    },
    {
      key: "Seller Accepted",
      action: "Accept",
      label: "Seller Accepted",
      icon: <img src={SellerAccepted} />,
    },
    {
      key: "Seller Rejected",
      action: "Reject",
      label: "Seller Rejected",
      icon: <img src={SellerRejected} />,
    },
    {
      key: "Under Review by WDTP",
      action: "Under Review by WDTP",
      label: "Under Review by WDTP",
      icon: <img src={UnderReviewByWDTP} />,
    },
    {
      key: "Invoice Raised",
      action: "Raise Invoice",
      label: "Invoice Raised",
      icon: <img src={InvoiceRaised} />,
    },
    {
      key: "Delivered",
      action: "Delivered",
      label: "Delivered",
      icon: (
        <LocalShippingOutlinedIcon sx={{ color: "#25B634" }} fontSize="small" />
      ),
    },
    {
      key: "In Transit",
      action: "In Transit",
      label: "In Transit",
      icon: <Transit />,
    },
    {
      key: "Cancelled",
      action: "Cancel",
      label: "Cancelled",
      icon: <CancelOutlinedIcon sx={{ color: "#B10E1C" }} fontSize="small" />,
    },
    {
      key: "Send to Warehouse",
      action: "Send to Warehouse",
      label: "Send to Warehouse",
      icon: <img src={UserSend} />,
    },
    {
      key: "Send to Owner",
      action: "Send to Owner",
      label: "Send to Owner",
      icon: <img src={UserSend} />,
    },
    {
      key: "Accept for Owner",
      action: "Accept for Owner",
      label: "Accept for Owner",
      icon: <img src={UserCheck} />,
    },
    {
      key: "Reject for Owner",
      action: "Reject for Owner",
      label: "Reject for Owner",
      icon: <img src={UserPlus} />,
    },
    {
      key: "Admin Accepted",
      action: "Admin Accepted",
      label: "Admin Accepted",
      icon: <img src={AdminAcceptedIcon} />,
    },
    {
      key: "Admin Rejected",
      action: "Admin Rejected",
      label: "Admin Rejected",
      icon: <img src={AdminRejectedIcon} />,
    },
    {
      key: "Accepted Rejected",
      action: "Accepted | Rejected",
      label: "Accepted | Rejected",
      icon: <img src={AcceptRejectIcon} />,
    },
    {
      key: "Action Required",
      action: "Action Required",
      label: "Action Required",
      icon: <img src={ActionRequiredIcon} />,
    },
    {
      key: "Open",
      action: "Open",
      label: "Open",
      icon: <ReplayIcon sx={{ transform: "rotate(-90deg)" }} />,
    },
    {
      key: "Re Processing",
      action: "Re-Processing",
      label: "Re-Processing",
      icon: <img src={InProgress} />,
    },
    {
      key: "Rejected",
      action: "Reject",
      label: "Rejected",
      icon: <NotInterestedIcon sx={{ color: "#EC2323" }} fontSize="small" />,
    },
    {
      key: "Active",
      action: "Active",
      label: "Active",
      icon: <img src={ActiveIcon} />,
    },
    {
      key: "Expired",
      action: "Expired",
      label: "Expired",
      icon: <img src={ExpiredIcon} />,
    },
    {
      key: "Closed",
      action: "Close",
      label: "Closed",
      icon: <CloseIcon sx={{ marginLeft: "-4px" }} />,
    },
    {
      key: "Open",
      action: "Reopen",
      label: "Reopen",
      icon: <img src={AdminAcceptedIcon} />,
    },
    {
      key: "Sold",
      action: "Sold",
      label: "Sold",
      icon: <VerifiedOutlinedIcon sx={{ color: "#25B634" }} fontSize="small" />,
    },
    {
      key: "Normal Usage",
      action: "Normal Usage",
      label: "Normal Usage",
      icon: <img src={NormalUsageIcon} />,
    },
    {
      key: "Needs Downsizing",
      action: "Needs Downsizing",
      label: "Needs Downsizing",
      icon: <img src={DownsizingIcon} />,
    },  
    {
      key: "Needs Upsizing",
      action: "Needs Upsizing",
      label: "Needs Upsizing",
      icon: <img src={UpsizingIcon} />,
    },
    {
      key: "Reassign to Admin",
      action: "Reassign to Admin",
      label: "Reassign to Admin",
      icon: <img src={ReassignToAdmin} />,
    },
    {
      key: "Confirmed for Warehouse",
      action: "Confirmed for Warehouse",
      label: "Confirmed for Warehouse",
      icon: <img src={WarehouseConfirmed} />,
    },
    {
      key: "In Stage for Warehouse",
      action: "In Stage for Warehouse",
      label: "In Stage for Warehouse",
      icon: <img src={InStageIcon} />,
    },
    {
      key: "Admin Accepted for Warehouse",
      action: "Admin Accepted for Warehouse",
      label: "Admin Accepted for Warehouse",
      icon: <img src={AdminAcceptedIcon} />,
    },
    {
      key: "Warehouse Completed",
      action: "Warehouse Completed",
      label: "Warehouse Completed",
      icon: <img src={WarehouseCompleted} />,
    }
  ];

  const styles = {
    scrollableMenu: {
      height: "auto",
      maxHeight: "300px",
      overflowX: "hidden",
      overflowY: "auto",
    } as React.CSSProperties,
    scrollbarStyles: `
      .scrollable-menu::-webkit-scrollbar {
        width: 6px;
      }
      .scrollable-menu::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 3px;
      }
      .scrollable-menu::-webkit-scrollbar-thumb:hover {
        background-color: #555;
      }
    `,
  };

  const getVariant = (status: string) => {
    switch (status?.toUpperCase().replace(/ /g, "_")) {
      case "APPROVED":
        return "approved";
      case "PENDING_REVIEW":
        return "pending-review";
      case "REJECTED":
      case "SOURCE_REJECTED":
      case "DESTINATION_REJECTED":
        return "rejected";
      case "ACCEPTED":
      case "SOURCE_ACCEPTED":
      case "DESTINATION_ACCEPTED":
      case "COMPLETED":
      case "ASSIGNED":
        return "accepted"
      case "CANCELLED":
        return "cancelled";
      case "SHIPPED":
        return "shipped";
      case "DELIVERED":
        return "delivered";
      case "PUBLISHED":
        return "published";
      case "SUBMIT_FOR_REVIEW":
        return "submit-for-review";
      case "OWNERSHIP_TRANSFERRED":
        return "ownership-transferred";
      case "CONTRACT_SIGN":
        return "contract-sign";
      case "PENDING_FOR_CONTRACT":
        return "pending-for-contract";
      case "UNDER_REVIEW":
        return "under-review";
      case "FINALIZED":
        return "finalized";
      case "UNPUBLISHED":
        return "unpublished";
      case "CONTRACT_SENT":
        return "contract-sent";
      case "CONTRACT_EXECUTED":
        return "contract-executed";
      case "INVOICE_SENT":
        return "invoice-sent";
      case "PAYMENT_RECEIVED":
        return "payment-received";
      case "UNDER_REVIEW_BY_SELLER":
        return "under-review-by-seller";
      case "SELLER_ACCEPTED":
        return "seller-accepted";
      case "SELLER_REJECTED":
        return "seller-rejected";
      case "UNDER_REVIEW_BY_WDTP":
        return "under-review-by-wdtp";
      case "INVOICE_RAISED":
        return "invoice-raised";
      case "IN_TRANSIT":
        return "in-transit";
      case "INVITED":
        return "invite";
      case "ACTION_REQUIRED":
        return "action-required";
      case "ADMIN_ACCEPTED":
        return "admin-accepted";
      case "ADMIN_REJECTED":
        return "admin-rejected";
      case "ACCEPTED_REJECTED":
        return "accepted-rejected";
      case "ACCEPT_FOR_OWNER":
        return "accept-for-owner";
      case "REJECT_FOR_OWNER":
        return "reject-for-owner";
      case "SEND_TO_OWNER":
        return "send-to-owner";
      case "CLOSED":
      case "FAILED":
        return "closed";
      case "IN_PROGRESS":
      case "IN_PROCESS":
        return "in-progress";
      case "RE_PROCESSING":
      case "REPUBLISHED":
        return "re-processing";
      case "UPLOADED":
        return "uploaded";
      case "UPLOAD_FAILED":
      case "DELETED":
        return "upload-failed";
      case "ACTIVE":
        return "active";
      case "EXPIRED": 
        return "expired";
      case "SOLD":
        return "sold";
      case "NEEDS_DOWNSIZING":
        return "needs-downsizing";
      case "NEEDS_UPSIZING":
        return "needs-upsizing";
      case "NORMAL_USAGE":
        return "normal-usage";
      case "SEND_TO_WAREHOUSE":
        return "send-to-warehouse";    
      case "REASSIGN_TO_ADMIN":
        return "reassign-to-admin";
      case "CONFIRMED_FOR_WAREHOUSE":
        return "confirmed-for-warehouse";
      case "IN_STAGE_FOR_WAREHOUSE":
        return "in-stage-for-warehouse";
      case "ADMIN_ACCEPTED_FOR_WAREHOUSE":
        return "admin-accepted-for-warehouse";
      case "WAREHOUSE_COMPLETED":
        return "warehouse-completed";
      case "CONFIRMED":
        return "confirmed";
      case "IN_STAGE":
        return "in-stage";
      case "SCHEDULED":
        return "scheduled";
      case "RE_OPEN":
        return "Re-Open";
      default:
        return "none";
    }
  };

  //it with give the current icon
  const getStatusIcon = (status: string) => {
    const option = statusOptions.find(
      (opt) =>
        opt.key?.toUpperCase().replace(/ /g, "_") ===
        status?.toUpperCase().replace(/ /g, "_")
    );
    return option ? option.icon : null;
  };

  //filter the label which is coming from props
  const getCurrentLabel = (status: string) => {
    const option = statusOptions.find(
      (opt) =>
        opt.key?.toUpperCase().replace(/[\s-]/g, "_") ===
        status?.toUpperCase().replace(/[\s-]/g, "_")
    );
    return option ? option.label : status;
  };

  const getStatusTooltip = (label: string) => {
    const getDesc = () => {
      switch (label) {
        case "Accepted":
          return "Request has been approved.";
        case "Rejected":
          return "Request has been turned down.";
        case "Cancelled":
          return "Request is called off.";
        case "Completed":
          return "Request is finished.";
        case "Deleted":
          return "Request is removed from the system.";
        case "Pending Review":
          return "Request is created and waiting for further action.";
        case "In Progress":
          return "Request is actively being worked on.";
        case "Under Review":
          return "Request has been submitted and it is under review by WDTP team.";
        case "Send to Owner":
          return "Request is sent to the container owner for their approval.";
        case "Admin Accepted":
          return "An admin has approved the request.";
        case "Admin Accepted for Warehouse":
          return "Admin has approved it for warehouse handling on behalf of warehouse.";
        case "Warehouse Completed":
          return "Warehouse has finished its part and ready.";
        case "In Transit":
          return "Containers are on the move.";
        case "Delivered":
          return "Shipment has arrived.";
        case "Admin Rejected":
          return "An admin has rejected the request.";
        case "In Process":
          return "Request is being actively processed.";
        case "Re Processing":
          return "Request is being run through the process again, usually after a failure.";
        case "Reassign to Admin":
          return "Request is sent back to an admin for further action.";
        case "Send to Warehouse":
          return "Request is routed to the warehouse team.";
        case "Confirmed for Warehouse":
          return "Warehouse has confirmed it received the request.";
        case "In Stage for Warehouse":
          return "Containers are staged at the warehouse, waiting on next steps.";
        case "Source Accepted":
          return "The sending account owner has approved the transfer.";
        case "Source Rejected":
          return "The sending account owner has declined.";
        case "Destination Accepted":
          return "The receiving account owner has approved the transfer.";
        case "Destination Rejected":
          return "The receiving account owner has declined.";
        case "Ownership Transferred":
          return "Ownership of the container officially changes.";
        case "Sold":
          return "Used for Private Sale completion.";
        case "Published":
          return "Listing goes live and becomes visible in marketplace search.";
        case "Unpublished":
          return "Listing is taken down from search, but can be restored later.";
        case "Republished":
          return "A previously unpublished listing is put back into search.";
        case "Finalized":
          return "Sell Request has reached its final agreed outcome.";
        case "Assigned":
          return "Owner is changed within a Account Owner.";
        case "Uploaded":
          return "The file has been attached to the request.";
        case "Uploading":
          return "File is actively being processed in the background.";
        case "Upload Failed":
          return "File processing did not succeed.";
        case "Closed":
          return "Request has been closed out.";
        case "Processing":
          return "Request is currently being worked on.";
        case "Success":
          return "A sub-step or operation completed successfully.";
        case "Failed":
          return "A sub-step or operation did not succeed.";
        case "Approved":
          return "A separate approval step has been granted.";
        case "Invoice Sent":
          return "An invoice has been issued for the request.";
        case "Payment Received":
          return "Payment for the request has come in.";
        case "Confirmed":
          return "A simple confirmation step has been completed.";
        case "In Stage":
          return "Warehouse side status to know where exactly a request containers are currently lying.";
        case "Scheduled":
          return "Request or action has been scheduled for later.";
        default:
          return null;
      }
    };
    const desc = getDesc();
    return desc ? `${label} - ${desc}` : label;
  };

  // const filteredOptions = statusOptions?.filter(
  //   (option) =>
  //     option.key?.toUpperCase().replace(/[\s-]/g, "_") !==
  //       currentStatus?.toUpperCase().replace(/[\s-]/g, "_") &&
  //     allowedLabels.includes(option.label)
  // );

  // Use dynamicLabels for filtering
  const filteredOptions = statusOptions?.filter(
    (option) =>
      option.key?.toUpperCase().replace(/[\s-]/g, "_") !==
        currentStatus?.toUpperCase().replace(/[\s-]/g, "_") &&
      ((dynamicLabels.length > 0 && serviceTypeId)
        ? dynamicLabels.includes(option.label)
        :allowedLabels.includes(option.label))
  );

  // Function to fetch status options
  const getAllStatus = async () => {

    if(dynamicLabels.length > 0 ){
      return ;
    }
    try {
      setIsLoading(true);
      const response = await SupportApiService.getAllStatusByServiceTypeId(
        serviceTypeId,
        currentStatus,
        isDestinationCompany
      );
      setDynamicLabels(CommonService.transformStatusList(response?.data || []));
    } catch (error) {
      console.log("Error occurred while fetching statuses:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>{styles.scrollbarStyles}</style>
      <Dropdown as={ButtonGroup} show={isOpen} onToggle={handleToggle} className="align-items-center">
        {/* {isLoading && <Spinner/>} */}
        {/* <Spinner/> */}
        {showTooltip ? (
          <Tooltip arrow title={getStatusTooltip(getCurrentLabel(currentStatus))} placement="right">
            <span>
              <Dropdown.Toggle
                variant={getVariant(currentStatus)}
                disabled={disableCondition}
                className="dropdown-status d-flex align-items-center"
              >
                {getStatusIcon(currentStatus)}{" "}
                <span>
                  {getCurrentLabel(currentStatus)}{" "}
                  {!disableCondition && (
                    <img src={ExpandMore} alt="CompanyIcn" width={12} height={7} />
                  )}
                </span>
              </Dropdown.Toggle>
            </span>
          </Tooltip>
        ) : (
          <Dropdown.Toggle
            variant={getVariant(currentStatus)}
            disabled={disableCondition}
            className="dropdown-status d-flex align-items-center"
          >
            {getStatusIcon(currentStatus)}{" "}
            <span>
              {getCurrentLabel(currentStatus)}{" "}
              {!disableCondition && (
                <img src={ExpandMore} alt="CompanyIcn" width={12} height={7} />
              )}
            </span>
          </Dropdown.Toggle>
        )}

        <Dropdown.Menu className="scrollable-menu" style={styles.scrollableMenu}>
        {isLoading ? (
          <Dropdown.Item className="d-flex align-items-center">
            <Spinner/> Loading...
          </Dropdown.Item>
        ) : (
          filteredOptions.map((option) => (
            <Dropdown.Item
              key={option.key}
              onClick={() => onStatusChange(option.key)}
              className={`dropdown-item-${option.label
                .toLowerCase()
                .replace(/ /g, "-")}`}
            >
              {showTooltip ? (
                <Tooltip arrow title={getStatusTooltip(option.label)} placement="right">
                  <span className="w-100 d-inline-block">
                    {option.icon} {option.action}
                  </span>
                </Tooltip>
              ) : (
                <>
                  {option.icon} {option.action}
                </>
              )}
            </Dropdown.Item>
          ))
        )}
        
      </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default StatusDropdown;
